import RatingBar from '@app/src/components/RatingBar'
import type { SxProps } from '@mui/material'
import { Box, Typography } from '@mui/material'
import React from 'react'

interface AssessmentSectionRatingProps {
  sectionName: string
  level?: number
  sx?: SxProps
  totalLevels?: number
}

const AssessmentSectionRating = ({ sectionName, totalLevels, level = 0, sx }: AssessmentSectionRatingProps) => {
  return (
    <Box py={1} sx={sx}>
      <Typography variant="subtitle2">{sectionName}</Typography>
      <RatingBar level={level} levelsCount={totalLevels} />
    </Box>
  )
}

export default AssessmentSectionRating
